import { http } from 'common/helpers/axios/axios-helper';
import { BaseHttpResponse } from 'common/interfaces/base-http-response.model';
import {
    TenantNotificationSettings,
    TenantSettingsViewModel,
    UpdateTenantViewModel,
    UpsertTenantSettingsPayload
} from '../model/tenant-notification';

const basePath = '/Tenant';

async function getTenantSettings(tenantId: string): Promise<BaseHttpResponse<TenantSettingsViewModel[]> | undefined> {
    return await http.get<TenantSettingsViewModel[]>(`${basePath}/settings/${tenantId}`);
}

async function updateTenantSetting(tenantId: string, payload: UpdateTenantViewModel) {
    return await http.put<TenantSettingsViewModel>(`${basePath}/settings/${tenantId}`, payload);
}

export const TenantNotificationService = {
    getTenantSettings,
    updateTenantSetting
};